<template>
  <div>
    <SimonModal
      :is-visible="showModal"
      @hide="close()"
      id="url-param-modal"
      :btn-cancel-title="getSlotText('txtModalCTA', 'Weiter')"
      css-class-cancel-button="filled"
    >
      <template v-slot:modalTitle>
        <slot name="imageModalHeader"></slot>
        <h1><slot name="txtModalHeader"></slot></h1>
      </template>
      <div><slot name="txtModalBody"></slot></div>
    </SimonModal>
  </div>
</template>

<script>

import SimonModal from '@/components/modal/SimonModal.vue'
import urlParam from '@/mixins/urlParam'
import { required } from 'vuelidate/lib/validators'

export default {
  components: { SimonModal },
  mixins: [urlParam],
  data () {
    return {
      showModal: false
    }
  },
  props: {
    urlParamName: {
      type: String,
      required
    },
    urlParamValue: {
      type: String,
      required
    },
    urlParamStartIndex: {
      type: String
    },
    urlParamEndIndex: {
      type: String
    }
  },
  mounted () {
    let urlParamValue = this.getURLParam(this.urlParamName)
    const startIndex = parseInt(this.urlParamStartIndex) ? parseInt(this.urlParamStartIndex) : 0
    const endIndex = parseInt(this.urlParamEndIndex) ? parseInt(this.urlParamEndIndex) : urlParamValue.length

    if (urlParamValue && urlParamValue.length >= endIndex) {
      if (startIndex && endIndex) {
        urlParamValue = urlParamValue.slice(startIndex, endIndex)
      }
      if (urlParamValue === this.urlParamValue) {
        this.showModal = true
        this.$store.commit('checkoutv2/ordering/_cart/addPromoTextRow', this.getSlotText('txtCartRow'))
      }
    }
  },
  methods: {
    close () {
      if (this.showModal) {
        this.showModal = false
        const data = {
          information_action: 'close',
          information_name: this.getSlotText('txtModalHeader'),
          information_ui_type: 'overlay',
          information_trigger: 'button'
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('information', data)
        }
      }
    }
  }
}
</script>
